import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'upsc-auto-redeem-dialog',
  templateUrl: './auto-redeem-dialog.component.html',
  styleUrls: ['./auto-redeem-dialog.component.scss'],
})
export class AutoRedeemDialogComponent implements OnInit {
  public dialogClass: string;
  public title: string;
  public titleClass: string;
  public message: string;
  public messageClass: string;
  public noMessage = 'Cancel';
  public yesMessage = 'Confirm';

  constructor(public dialogRef: MatDialogRef<AutoRedeemDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (this.data) {
      this.dialogClass = this.data.dialogClass ? this.data.dialogClass : '';
      this.title = this.data.title ? this.data.title : '';
      this.titleClass = this.data.titleClass ? this.data.titleClass : '';
      this.message = this.data.message;
      this.messageClass = this.data.messageClass ? this.data.messageClass : '';
      this.noMessage = this.data.noMessage ? this.data.noMessage : this.noMessage;
      this.yesMessage = this.data.yesMessage ? this.data.yesMessage : this.yesMessage;
    }
  }

  public ngOnInit() {
  }

  public clickedYes() {
    this.closeDialog("YES");
  }

  public clickedNo() {
    this.closeDialog("NO");
  }

  closeDialog(option: "YES" | "NO") {
    this.dialogRef.close(option);
  }
}
